module.exports = __webpack_public_path__ + "static/media/6510.35617278.jpg";